import { Injectable } from '@angular/core';
import { StorageService } from '@core/services/storage.service';
import { v4 as uuidv4 } from 'uuid';
import { ConsentCookie } from '@core/services/cookie-consent/cookie-consent';

@Injectable({
    providedIn: 'root'
})
export class UniqueIdentifierService {
    private readonly GUID_KEY = 'guid_key';

    constructor(private readonly storageService: StorageService) {}

    public getGUID(cookieInformation?: ConsentCookie): string {
        const key = this.storageService.get(this.GUID_KEY);

        // if we already have a GUID key set we will use it;
        if (key) {
            return key;
        }

        // in case of the cookie information, so we don't have yet a GUID we will check for the user_uid from cookie consent;
        if (cookieInformation && cookieInformation.user_uid) {
            return cookieInformation.user_uid;
        }

        // if we don't have any cookie yet set, we will generate a new one and return it
        return this.setGUID();
    }

    /**
     * This will save a GUID on the local storage.
     * Why the local storage??
     * To track all the events with the same GUID, when is inside the same anonymous browser (like new tabs)
     * @private
     */
    private setGUID(): string {
        const guid = uuidv4();
        this.storageService.set(this.GUID_KEY, guid);
        return guid;
    }
}
